import { useState } from 'react';
import toast from 'react-hot-toast';
import { useBusinessStore } from '../store/useBusinessStore';
import { useAuthStore } from '../store/useAuthStore';
import { supabase } from '../supabaseClient';

const DEMO_BUSINESS_IDS = ['9001', '9002', '9003'];
const isMissingColumn = (error) => ['42703', 'PGRST204'].includes(error?.code) || /pedidos_nacen_listos/i.test(error?.message || '');

// «Pedidos sin cocina»: con la opción encendida, los pedidos nuevos (de la app o del bot) nacen en «Listo» y el domiciliario los ve al instante.
// La regla la aplica un disparador de la base (migración 20261007a_orders_ready_by_default.sql); aquí solo se enciende o apaga y se guarda antes de reflejarlo.
export const useReadyOrders = () => {
  const { masterDb, activeBusinessId, setMasterDb } = useBusinessStore();
  const { userRole } = useAuthStore();
  const [saving, setSaving] = useState(false);
  const business = (Array.isArray(masterDb) ? masterDb : []).find((b) => String(b.id) === String(activeBusinessId)) || null;
  const readOnlyDemo = DEMO_BUSINESS_IDS.includes(String(activeBusinessId)) && userRole !== 'master';
  const enabled = business?.pedidos_nacen_listos === true;

  const setEnabled = async (value) => {
    if (!business) return false;
    if (readOnlyDemo) { toast.error('Modo solo lectura: las cuentas demo no se pueden modificar.'); return false; }
    setSaving(true);
    try {
      const { error } = await supabase.from('businesses').update({ pedidos_nacen_listos: value }).eq('id', business.id);
      if (error) {
        toast.error(isMissingColumn(error)
          ? 'Falta ejecutar la migración 20261007a_orders_ready_by_default.sql en Supabase para usar esta opción.'
          : 'No se pudo guardar. Inténtalo de nuevo.');
        return false;
      }
      setMasterDb((current) => (Array.isArray(current) ? current : []).map((b) => (String(b.id) === String(business.id) ? { ...b, pedidos_nacen_listos: value } : b)));
      toast.success(value ? 'Los pedidos nuevos entrarán como «Listo»' : 'Los pedidos nuevos entrarán como pendientes');
      return true;
    } finally {
      setSaving(false);
    }
  };

  return { enabled, saving, readOnlyDemo, hasBusiness: Boolean(business), setEnabled };
};
